import classNames from "classnames";
import { SmallBody } from "helpers/TypographyComponents";

import styles from "./style.module.scss";

interface IProgressBar {
    /**
     * Label for the progress bar ex 1/3 {{users}}
     */
    label?: string;
    /**
     * Width pixels value, default 200px
     */
    width?: number;
    /**
     * Progress bar width 100%
     */
    fullWidth?: boolean;
    /**
     * Current value/total
     */
    value: number;
    /**
     * Total of the progress bar, maximum size
     */
    total: number;
    /**
     * Whether to show label above bar. If not, aligned.
     */
    column?: boolean;
    /**
     * Align content to the start (left) instead of center.
     */
    alignStart?: boolean;
}
/**
 * This component render a progress bar
 */
const ProgressBar = ({
    label,
    width,
    value,
    total,
    fullWidth = false,
    column = false,
    alignStart = false,
}: IProgressBar) => {
    const percentage = (value * 100) / total;

    return (
        <div
            className={classNames({
                [styles["progress-bar-wrapper"]]: true,
                [styles["column"]]: column,
                [styles["full-width"]]: fullWidth,
                [styles["align-start"]]: alignStart,
            })}
        >
            {label && <SmallBody color="grey">{`${value}/${total} ${label}`}</SmallBody>}
            <div className={styles["progress-bar"]} style={width ? { width: `${width}px` } : {}}>
                <div
                    className={classNames({
                        [styles["progress-bar-fill"]]: true,
                        [styles["fulfilled"]]: Math.min(percentage, 100) == 100,
                    })}
                    style={{ width: `${Math.min(percentage, 100)}%` }}
                />
            </div>
        </div>
    );
};

export default ProgressBar;
